//1.Import
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Modal from 'bootstrap/js/dist/modal';
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import GspAnimate from './modules/GspAnimate';
import ImageParallax from './modules/ImageParallax';
import OverlapSection from './modules/OverlapSection';
import Navbar from './modules/Navbar';
//2.Initialization
gsap.registerPlugin(ScrollTrigger,ScrollSmoother);
const navbar=new Navbar();
const imageParallax=new ImageParallax();
const overlapSection=new OverlapSection();
const gspAnimate= new GspAnimate();

class Layout {
    constructor(options = {}) {
        this.options = options;
        navbar.init();
        imageParallax.init();
        overlapSection.init();
        gspAnimate.gspFadeUp();
        this.initScrollSmooth();
        this.removeDoubleTitle();
    }

    initScrollSmooth() {
        let scroller;
        if (this.options.enableSmoothScroll !== false) {
            // Disable smooth scrolling for mobile by checking if the device is touch-enabled
            if (ScrollTrigger.isTouch !== 1 && window.innerWidth > 768) { // Adjust 768px as needed for your breakpoint
                scroller = ScrollSmoother.create({
                    smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
                    effects: true, // looks for data-speed and data-lag attributes on elements
                });
            }
        }
        return scroller;
    }

    removeDoubleTitle(){
        const titleTags = document.getElementsByTagName('title');
        // Check if there are duplicates
        if (titleTags.length > 1) {
            // Keep the first <title> element
            const firstTitle = titleTags[0];
            // Loop through the rest and remove them
            for (let i = 1; i < titleTags.length; i++) {
            titleTags[i].parentNode.removeChild(titleTags[i]);
            }
        }
    }
    
}

export default Layout;
